export const quesiton1 = `Dla kogo jest przeznaczone jest to badanie?`;
export const question2 = `Przecież moje zachowanie zależy od okoliczności – co ma do tego mój typ osobowości?`;
export const question3 = `Czy są lepsze i gorsze wyniki?`;
export const question4 = `Czy wyniki badania mogą pokazać że „nie nadaję się” do bycia agentem?`;
export const question5 = `Na ile wynik badania trafnie zobrazują moją osobowość?`;
